import React, { Fragment, useEffect, useState } from 'react';
import { useStoreState, useStoreActions } from 'easy-peasy';
import { useHistory } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import {
	Stack,
	Box,
	Accordion,
	AccordionSummary,
	AccordionDetails,
	Typography,
	Modal,
	Fade,
	Backdrop
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import KitAccordionSummary from './KitAccordionSummary';
import KitAccordionDetails from './KitAccordionDetails';
import KitItemDetail from './KitItemDetail';
import utils from 'components/utils';

const List = props => {
	const theme = useTheme();
	const translate = utils.useI18N();
	const history = useHistory();
	const loading = useStoreState(state => state.kit.loading);
	const items = useStoreState(state => state.kitUsers.items);
	const load = useStoreActions(dispatch => dispatch.kitUsers.load);
	const expanded = useStoreState(state => state.kitUsers.expanded);
	const setExpanded = useStoreActions(dispatch => dispatch.kitUsers.setExpanded);
	const detailEan = useStoreState(state => state.kitUsers.detailEan);
	const setDetailEan = useStoreActions(dispatch => dispatch.kitUsers.setDetailEan);
	const openModalDetail = Boolean(detailEan);

	const handleExpanded = index => (event, isExpanded) => {
		setExpanded(isExpanded ? index : -1);
	};

	const expandItem = id => {
		setExpanded(-1);

		items.forEach((value, index) => {
			if (value.id.toString() === id.toString()) {
				setExpanded(index);
			}
		});
	};

	const handleCloseDetail = _ => {
		setDetailEan(null);
	};

	useEffect(() => {
		load();
		expandItem(-1);
	}, []);

	useEffect(() => {
		//Caso in cui c'è un kit specifico da visualizzare
		if (history.location.pathname.includes('/kit/') && items.length > 0) {
			const splitUrl = history.location.pathname.split('/kit/');
			if (splitUrl.length >= 2) {
				const kitCode = splitUrl[1];
				//const element = document.getElementById('kit_' + kitIdCode);
				const element = document.querySelector('[id^="kit_' + kitCode + '"]');
				if (!element) return;
				const kitId = element.id.split('-')[1];
				const top = element.offsetTop;
				expandItem(kitId);
				window.scrollTo(0, top);
			}
		}
	}, [items]);

	return (
		<Stack
			direction="column"
			justifyContent="flex-start"
			alignItems="flex-start"
			spacing={0.5}
			variant="wrapperSection"
		>
			{!loading && items.length === 0 && <Typography variant="titleSection">{translate('kit.noKit')}</Typography>}
			{!loading && items.length > 0 && (
				<Box sx={{ width: '100%' }}>
					{items.map((kit, index) => (
						<Stack
							key={kit.id}
							id={'kit_' + kit.internalCode + '-' + kit.id}
							spacing={0}
							sx={{ marginBottom: '20px !important' }}
						>
							<Accordion variant="listing" expanded={expanded === index} onChange={handleExpanded(index)}>
								<AccordionSummary expandIcon={<ExpandMoreIcon />}>
									<KitAccordionSummary kit={kit} />
								</AccordionSummary>
								<AccordionDetails>
									{expanded === index && <KitAccordionDetails kit={kit} />}
								</AccordionDetails>
							</Accordion>
						</Stack>
					))}
				</Box>
			)}
			{/* Modal dettaglio titolo */}
			<Modal
				aria-labelledby="transition-modal-detail-title"
				aria-describedby="transition-modal-detail-description"
				open={openModalDetail}
				onClose={handleCloseDetail}
				closeAfterTransition
				slots={{ backdrop: Backdrop }}
				slotProps={{ backdrop: { timeout: 500 } }}
			>
				<Fade in={openModalDetail}>
					<Box
						sx={{
							position: 'absolute',
							top: { xs: '50%', md: '50%', sm: '40%' },
							left: '50%',
							transform: 'translate(-50%, -50%)',
							backgroundColor: theme.palette.custom.white,
							borderWidth: '1px',
							borderStyle: 'solid',
							borderColor: theme.palette.primary.main,
							boxShadow: 24,
							padding: '10px',
							width: { xs: '100%', md: '850px', sm: '95%' }
						}}
					>
						{/* Inserita verifica openModalDetail per evitare errore in chiusura modale */}
						{openModalDetail && <KitItemDetail item={detailEan} onClose={handleCloseDetail} />}
					</Box>
				</Fade>
			</Modal>
		</Stack>
	);
};

export default List;
